var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorldwide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 96,
    viewBox: "0 0 88 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#worldwide_svg__filter0_d_511_5946)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#worldwide_svg__paint0_linear_511_5946)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#worldwide_svg__paint1_linear_511_5946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 40C30 35.2261 31.8964 30.6477 35.2721 27.2721C38.6477 23.8964 43.2261 22 48 22C52.7739 22 57.3523 23.8964 60.7279 27.2721C64.1036 30.6477 66 35.2261 66 40C66 44.7739 64.1036 49.3523 60.7279 52.7279C57.3523 56.1036 52.7739 58 48 58C43.2261 58 38.6477 56.1036 35.2721 52.7279C31.8964 49.3523 30 44.7739 30 40ZM51.1583 25.4206C47.8514 24.704 44.399 25.1331 41.3681 26.6373C38.3371 28.1416 35.9076 30.6317 34.4785 33.6988L38.0269 37.2472C38.1785 37.3982 38.3838 37.483 38.5978 37.483C38.8117 37.483 39.017 37.3982 39.1686 37.2472L39.4044 37.0092V35.2989C39.4044 35.0963 39.4443 34.8957 39.5219 34.7085C39.5994 34.5213 39.713 34.3512 39.8563 34.208C39.9996 34.0647 40.1696 33.9511 40.3568 33.8735C40.544 33.796 40.7446 33.7561 40.9472 33.7561H43.2989C43.5134 33.7561 43.7191 33.6709 43.8708 33.5192C44.0225 33.3675 44.1077 33.1618 44.1077 32.9472C44.1077 30.7961 45.8489 29.0528 48 29.0528H50.3517C50.5658 29.0528 50.7712 28.9679 50.9228 28.8166C51.0745 28.6654 51.1599 28.4603 51.1605 28.2461V25.4206H51.1583ZM33.3941 36.9805C32.6249 40.7029 33.3052 44.5784 35.2962 47.8162C37.2872 51.054 40.4388 53.4099 44.1077 54.4031V53.57L41.7539 51.2183V47.6919L39.4044 45.3403V42.3517C39.4044 42.1491 39.4443 41.9484 39.5219 41.7613C39.5994 41.5741 39.713 41.404 39.8563 41.2607C39.9996 41.1175 40.1696 41.0038 40.3568 40.9263C40.544 40.8488 40.7446 40.8089 40.9472 40.8089H50.3517C52.5028 40.8089 54.2461 42.55 54.2461 44.7011V45.6048C55.3525 45.8802 56.2253 46.753 56.503 47.8616H60.6774C61.7912 46.0655 62.5106 44.0532 62.788 41.958C63.0654 39.8628 62.8943 37.7326 62.2863 35.7086C61.6782 33.6845 60.6469 31.8127 59.2608 30.2173C57.8747 28.6219 56.1654 27.3392 54.2461 26.4543V28.2461C54.2461 30.395 52.5028 32.1384 50.3517 32.1384H48C47.8938 32.1384 47.7886 32.1593 47.6905 32.1999C47.5923 32.2406 47.5032 32.3002 47.428 32.3753C47.3529 32.4504 47.2934 32.5396 47.2527 32.6377C47.2121 32.7358 47.1911 32.841 47.1911 32.9472C47.1911 35.0983 45.45 36.8417 43.2989 36.8417H42.49V38.2875L41.3506 39.4292C39.8298 40.9499 37.3635 40.9499 35.8428 39.4292L33.3919 36.9783L33.3941 36.9805ZM58.1295 50.9494H55.8374C55.531 50.9494 55.2276 50.8889 54.9447 50.7714C54.6617 50.6539 54.4048 50.4817 54.1885 50.2646C53.9723 50.0476 53.8011 49.79 53.6846 49.5066C53.5682 49.2232 53.5088 48.9196 53.51 48.6132L53.5034 48.6044C53.5008 48.6017 53.4979 48.5994 53.4946 48.5978H53.4857C52.8685 48.5978 52.2765 48.3526 51.84 47.9161C51.4035 47.4796 51.1583 46.8876 51.1583 46.2704V44.7055C51.1583 44.4914 51.0734 44.286 50.9222 44.1343C50.771 43.9827 50.5658 43.8972 50.3517 43.8967H42.49V44.0642L44.8417 46.4158V49.9422L47.1911 52.2939V54.8946C49.1856 55.0057 51.182 54.7136 53.061 54.0358C54.9401 53.3579 56.6632 52.3082 58.1273 50.9494H58.1295Z",
    fill: "url(#worldwide_svg__paint2_linear_511_5946)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "worldwide_svg__paint0_linear_511_5946",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "worldwide_svg__paint1_linear_511_5946",
    x1: 48,
    y1: 0,
    x2: 27,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "worldwide_svg__paint2_linear_511_5946",
    x1: 41.813,
    y1: 22,
    x2: 53.625,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#305CF0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "worldwide_svg__filter0_d_511_5946",
    x: 0,
    y: 0,
    width: 88,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.94902 0 0 0 0 0.952941 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_511_5946"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_511_5946",
    result: "shape"
  })))));
}

export default SvgWorldwide;